export default class Compare {
    constructor() {
        this.compareBtn = document.getElementById("jsCompare");
        this.compareViewModal = document.getElementById("jsCompareView");
        this.compareModal = document.getElementById("jsCompareModal");
        this.closeModal = document.getElementById("jsCompareModalClose");
        this.compareRemove = document.querySelectorAll(".jsRemoveCompare");

        if (this.compareBtn) {
            this.events();
        }
    }

    events() {
        const _this = this;

        this.compareBtn.addEventListener("click", this.addToCompare.bind(this));

        this.compareViewModal.addEventListener(
            "click",
            this.viewCompare.bind(this)
        );

        this.compareRemove.forEach((el) =>
            el.addEventListener("click", this.removeFromCompare.bind(this))
        );

        document.addEventListener("click", function (e) {
            if (e.target && e.target.id === "jsCompareModalClose") {
                e.target.parentElement.parentElement.style.display = "none";
                document.body.classList.remove("is-fixed");
            }

            if (e.target && e.target.className === "jsRemoveCompare") {
                document.getElementById("jsCompareModal").style.display =
                    "flex";
                document.body.classList.add("is-fixed");
            }

            if (e.target && e.target.id === "jsCompareView") {
                document.getElementById("jsCompareModal").style.display =
                    "flex";
                document.body.classList.add("is-fixed");
            }

            if (e.target && e.target.className === "jsRemoveCompare product-compare__remove") {
                _this.removeFromCompare(e);
            }
        });
    }

    addToCompare(e) {
        e.preventDefault();

        const container = jQuery("#jsCompare");
        const id = this.compareBtn.dataset.productId;
        const _this = this;

        // Add loader
        container.block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        const data = {
            action: "addToCompare",
            productId: id,
        };

        jQuery.ajax({
            url: ajax.ajaxurl,
            type: "POST",
            data: data,
            success: function (response) {
                document.getElementById("jsCompareModal").outerHTML =
                    response.data;
                document.getElementById("jsCompareModal").style.display =
                    "flex";
                document.body.classList.add("is-fixed");
                jQuery(".blockUI").remove();
                _this.compareRemove =
                    document.querySelectorAll(".jsRemoveCompare");
                _this.compareRemove.forEach((el) =>
                    el.addEventListener("click", _this.removeFromCompare.bind(this))
                );
            },
            error: function (request) {
                console.log(request.responseText);
            },
        });
    }

    viewCompare(e) {
        e.preventDefault();
        this.compareModal.style.display = "flex";
        document.body.classList.add("is-fixed");
    }

    removeFromCompare(e) {
        console.log("removeFromCompare");

        e.preventDefault();
        const id = e.target.dataset.compareId;
        const container = jQuery("#jsCompareModalContent");

        // Add loader
        container.block({
            message: null,
            overlayCSS: {
                cursor: "none",
                background: "#fff",
                opacity: 0.6,
            },
        });

        const data = {
            action: "removeFromCompare",
            productId: id,
        };

        jQuery.ajax({
            url: ajax.ajaxurl,
            type: "POST",
            data: data,
            success: function (response) {
                const removeElements = (elms) =>
                    elms.forEach((el) => el.remove());
                removeElements(
                    document.querySelectorAll('[data-compare-id~="' + id + '"]')
                );
                jQuery(".blockUI").remove();
            },
            error: function (request) {
                console.log(request.responseText);
            },
        });
    }
}
